





































































































import { Component, Vue, Prop } from 'vue-property-decorator'
import { Product } from '../../modules/class/ProductCategory'
import Tabs from '../../modules/class/Tabs'
import RemoveTag from '@/components/Parts/RemoveTag.vue'

@Component({
  components: {
    RemoveTag
  }
})
export default class QuickViewModal extends Vue {
  // ------------------------------------------------------------------------------------------------
  // props
  @Prop() private modalProduct!: Product
  @Prop() private params!: Record<string, unknown>

  // ------------------------------------------------------------------------------------------------
  // computed

  /**
   * contactShimadzuの設定を取得する
   */
  get contactShimadzu() {
    return drupalSettings.vueComponent.productCategory.contactShimadzu ?? []
  }

  /**
   * 製品のタブを取得する
   */
  private get tabs() {
    const linkedLabelAndLinkTabs: Tabs[] = []
    const displayTargets = ['downloads', 'applications', 'consumables']
    let value = ''
    // downloads, applications, consumables の中でリンクが空文字でないものを抽出
    for (const tab in this.modalProduct.tabs) {
      value = this.modalProduct.tabs[tab]
      if (displayTargets.includes(tab) && value !== '') {
        // tabにキーがあってtab_labelsにない場合は、キーをラベルとして表示する
        if (this.modalProduct.tabLabels[tab]) {
          linkedLabelAndLinkTabs.push({
            label: this.modalProduct.tabLabels[tab],
            link: value
          })
        } else {
          linkedLabelAndLinkTabs.push({ label: tab, link: value })
        }
      }
    }
    return linkedLabelAndLinkTabs
  }

  // ------------------------------------------------------------------------------------------------
  // methods

  /**
   * フォームへ遷移する
   */
  private moveToForm(item: Tabs) {
    const joinChar = item.link.indexOf('?') === -1 ? '?' : '&'

    let link = item.link

    // Webformに遷移する場合、パラメータをセット
    if (item.webform && item.webform.length > 0) {
      const params: string[] = []
      for (const key in this.params) {
        const value = this.params[key]
        params.push(`${key}=${value}`)
      }
      link += joinChar + params.join('&')
    }

    if (item.target && item.target.length > 0) {
      open(link, item.target)
    } else {
      window.location.href = link
    }
  }
}
